import { createContext, useCallback, useContext, useState } from "react";
import MediaPlayer from "@/components/MediaPlayer";

// Lecteur audio global : le composant MediaPlayer reste monté tant que le fichier est ouvert,
// donc l'audio continue en arrière-plan quand la page plein écran est minimisée (mini-barre)
// ou quand l'utilisateur navigue ailleurs dans l'app.
const PlayerCtx = createContext(null);
export const usePlayer = () => useContext(PlayerCtx);

export function PlayerProvider({ children }) {
  const [file, setFile] = useState(null);
  const [minimized, setMinimized] = useState(false);

  const open = useCallback((f) => { setFile(f); setMinimized(false); }, []);
  const close = useCallback(() => { setFile(null); setMinimized(false); }, []);
  const minimize = useCallback(() => setMinimized(true), []);
  const expand = useCallback(() => setMinimized(false), []);

  return (
    <PlayerCtx.Provider value={{ open, close, minimize, expand, isOpen: !!file && !minimized, hasPlayer: !!file, minimized }}>
      {children}
      {/* key=file.id : changer de fichier remonte un composant neuf — sinon l'ancien titre/état reste affiché */}
      {file && <MediaPlayer key={file.id} file={file} onClose={close} minimized={minimized} onMinimize={minimize} onExpand={expand} />}
    </PlayerCtx.Provider>
  );
}
